export default "__VITE_ASSET__2bcb2716__"